/**
 * @generated SignedSource<<1305a58b6e56687f69bffe7d119fb73d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesTable_package$data = {
  readonly groupedRates: ReadonlyArray<{
    readonly date: {
      readonly id: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableDateRow_groupedRate">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableDateRow_package" | "RoomRatesTableHead_package">;
  readonly " $fragmentType": "RoomRatesTable_package";
};
export type RoomRatesTable_package$key = {
  readonly " $data"?: RoomRatesTable_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTable_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesTable_package",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GroupedRate",
      "kind": "LinkedField",
      "name": "groupedRates",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PackageDate",
          "kind": "LinkedField",
          "name": "date",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RoomRatesTableDateRow_groupedRate"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesTableHead_package"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesTableDateRow_package"
    }
  ],
  "type": "Package",
  "abstractKey": null
};

(node as any).hash = "3375f77dc35d197f18b3dbfa486111c9";

export default node;
